(function () {
  if (window.__productCardFormReady) return;
  window.__productCardFormReady = true;

  var initializedAttribute = 'data-product-card-form-initialized';

  function updateCardForms(root) {
    var scope = root || document;
    var productInfos = Array.prototype.slice.call(
      scope.querySelectorAll('product-info.product--collection-form[data-url]')
    );

    if (!productInfos.length) return;

    productInfos.forEach(function (productInfo) {
      if (productInfo.hasAttribute(initializedAttribute)) return;

      var pageUrl = productInfo.dataset.url;
      if (!pageUrl) return;

      productInfo.setAttribute(initializedAttribute, 'pending');

      fetch(pageUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sectionElement = doc.querySelector('product-info[id^="MainProduct"]');
          if (!sectionElement) {
            productInfo.setAttribute(initializedAttribute, 'missing-source');
            return;
          }

          var sectionId = sectionElement.dataset.section;
          if (!sectionId) {
            productInfo.setAttribute(initializedAttribute, 'missing-section');
            return;
          }

          productInfo.id = sectionElement.id;
          productInfo.dataset.section = sectionId;

          productInfo.querySelectorAll('product-form').forEach(function (form) {
            form.dataset.sectionId = sectionId;

            var productForm = form.querySelector('form');
            var submitButton = form.querySelector('button[type="submit"]');
            var inputSectionId = form.querySelector('[name="section-id"]');

            if (productForm) productForm.id = 'product-form-' + sectionId;
            if (submitButton) submitButton.id = 'ProductSubmitButton-' + sectionId;
            if (inputSectionId) inputSectionId.value = sectionId;
          });

          productInfo.setAttribute(initializedAttribute, 'true');
        })
        .catch(function (error) {
          productInfo.removeAttribute(initializedAttribute);
          console.error('Product card form source failed:', error);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateCardForms(document);
    });
  } else {
    updateCardForms(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    updateCardForms(event.target);
  });
})();
